<template>
  <div>
    <div class="container-fluid">
      <div class="llp-container-section heightcontainer">
        <top-header id="height2"></top-header>
        <main-menu id="height3"></main-menu>
        <!-- Start the code for this screen here -->
        <div
          id="customer"
          class="container-fluid overflow-auto pb-4 menu-margin-top"
          style="padding-left: 0px; padding-right: 0px"
        >
          <div class="llp-container-section mr-sm-3 mr-lg-0" style="z-index: 1">
            <nav class="navbar navbar-expand-lg bg-info text-white">
              <span>
                <b>Search Customer</b>
              </span>
            </nav>
            <!--  Search Section with various options-->
            <!--  Display Error message that one search param required-->
            <div
              class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2"
            >
              <div
                class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center"
              >
                <label for="firstName" class="col-form-label col-form-label-sm"
                  >First Name</label
                >
              </div>
              <div
                class="col-12 col-md-12 justify-content-end align-items-center"
              >
                <input
                  type="text"
                  id="firstName"
                  name="First Name"
                  v-model.trim="searchCriteria.firstName"
                  class="form-control input-sm"
                />
              </div>
              <div
                class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center"
              >
                <label for="middleName" class="col-form-label col-form-label-sm"
                  >Middle Name</label
                >
              </div>
              <div
                class="col-12 col-md-12 justify-content-end align-items-center"
              >
                <input
                  type="text"
                  id="middleName"
                  name="Middle Name"
                  v-model.trim="searchCriteria.middleName"
                  class="form-control input-sm"
                />
              </div>
              <div
                class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center"
              >
                <label for="lastName" class="col-form-label col-form-label-sm"
                  >Last Name</label
                >
              </div>
              <div
                class="col-12 col-md-12 justify-content-end align-items-center"
              >
                <input
                  type="text"
                  id="lastName"
                  name="Last Name"
                  v-model.trim="searchCriteria.lastName"
                  class="form-control input-sm"
                />
              </div>
            </div>
            <div
              class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2"
            >
              <div
                class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center"
              >
                <label
                  for="businessName"
                  class="col-form-label col-form-label-sm"
                  >Business Name</label
                >
              </div>
              <div
                class="col-12 col-md-12 justify-content-end align-items-center"
              >
                <input
                  type="text"
                  id="businessName"
                  name="Business Name"
                  v-model.trim="searchCriteria.businessName"
                  class="form-control input-sm"
                />
              </div>
              <div
                class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center"
              >
                <label for="email" class="col-form-label col-form-label-sm"
                  >Email</label
                >
              </div>
              <div
                class="col-12 col-md-12 justify-content-end align-items-center"
              >
                <input
                  type="text"
                  id="email"
                  name="Email"
                  v-model.trim="searchCriteria.email"
                  class="form-control input-sm"
                />
              </div>
              <div
                class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center"
              >
                <label for="fraudInd" class="col-form-label col-form-label-sm"
                  >Fraud Status</label
                >
              </div>
              <div
                class="col-12 col-md-12 d-flex justify-content-end align-items-center"
              >
                <select
                  id="fraudInd"
                  v-model.trim="searchCriteria.fraudInd"
                  class="form-control input-sm"
                >
                  <option disabled value>Select Status</option>
                  <option
                    v-for="(fraud, index) in fraudIndOptions"
                    v-bind:value="fraud.value"
                    v-bind:key="index"
                  >
                    {{ fraud.name }}
                  </option>
                </select>
              </div>
            </div>
            <div
              class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2"
            >
              <div
                class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center"
              >
                <label for="state" class="col-form-label col-form-label-sm"
                  >State</label
                >
              </div>
              <div
                class="col-12 col-md-12 d-flex justify-content-end align-items-center"
              >
                <select
                  id="state"
                  v-model.trim="searchCriteria.state"
                  class="form-control input-sm"
                >
                  <option disabled value>Select a State</option>
                  <option
                    v-for="state in states"
                    v-bind:value="state.stateN"
                    v-bind:key="state.stateFipsC"
                  >
                    {{ state.stateN }}
                  </option>
                </select>
              </div>
              <div
                class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center"
              >
                <label for="zip" class="col-form-label col-form-label-sm"
                  >City</label
                >
              </div>
              <div
                class="col-12 col-md-12 d-flex justify-content-end align-items-center"
              >
                <input
                  type="text"
                  id="zip"
                  v-model.trim="searchCriteria.city"
                  class="form-control input-sm"
                />
              </div>
            </div>

            <div class="center mt-2 mb-3">
              <button
                type="submit"
                @click="onSearch"
                class="btn btn-secondary mr-2"
              >
                Search
              </button>
              <button
                type="submit"
                @click="resetsearch"
                class="btn btn-secondary"
              >
                Reset
              </button>
            </div>

            <center>
              <span :style="msgcolor"
                ><b>{{ message }}</b></span
              >
            </center>
            <nav class="navbar navbar-expand-lg bg-info text-white">
              <span>
                <b>Display Customer</b>
              </span>
            </nav>
            <div class="row justify-content-center">
              <div class="col">
                <div
                  class="table-responsive table-responsive-sm tbl-update-dealer"
                >
                  <v-table
                    id="customerListTable"
                    :data="customersList"
                    class="table table-sm table-bordered table-striped"
                  >
                    <thead
                      class="table-month-header-blue wrap-text"
                      slot="head"
                    >
                      <v-th sortKey="customerId">View/Edit</v-th>
                      <v-th sortKey="customerId">View/Deals</v-th>
                      <v-th sortKey="firstName">Customer Name</v-th>
                      <v-th sortKey="businessName">Business Name</v-th>
                      <v-th sortKey="email">Email</v-th>
                      <v-th sortKey="address">City</v-th>
                      <v-th sortKey="address">State</v-th>
                      <v-th sortKey="fraudInd">Fraud</v-th>
                    </thead>
                    <tbody slot="body" slot-scope="{ displayData }">
                      <tr
                        v-for="(customer, cindex) in displayData"
                        :key="cindex"
                      >
                        <td class="center">
                          <button
                            type="submit"
                            class="btn btn-secondary btn-edit"
                            :disabled="!checkAccess('updateCustomer')"
                            :class="{'disabled':!checkAccess('updateCustomer')}"
                            @click="getcustomerDate(customer.customerId)"
                          >
                            View/Edit
                          </button>
                        </td>
                        <td class="center">
                          <button
                            class="btn btn-secondary btn-edit"
                            @click="viewDealsApps(customer.customerId)"
                          >
                            View Deals
                          </button>
                        </td>
                        <td class="table-month-td">
                          {{
                            customer.firstName +
                            " " +
                            customer.middleName +
                            " " +
                            customer.lastName
                          }}
                        </td>
                        <td class="table-month-td">
                          {{ customer.businessName }}
                        </td>
                        <td class="table-month-td">{{ customer.digitalContactInfo.email }}</td>
                        <td class="table-month-td">{{ customer.address.city }}</td>
                        <td class="table-month-td">{{ customer.address.dstateFip ? customer.address.dstateFip.stateN : '' }}</td>
                        <td class="table-month-td">{{ customer.fraudInd }}</td>
                      </tr>
                    </tbody>
                  </v-table>
                  <template v-if="customersList.length == 0 && !isLoading">
                      <center>
                          <span>
                              <b>No records found</b>
                              <br />
                          </span>
                      </center>
                  </template>
                  <template v-if="isLoading">
                        <div class="d-flex justify-content-center align-items-center">
                          <strong>Loading...</strong>
                          <b-spinner variant="primary" label="Spinning"></b-spinner>
                        </div>
                  </template>

                  <b-pagination v-if="totalRows > 0 && !isLoading" v-model="currentPage" :total-rows="totalRows"
                      :per-page="pageSize" aria-controls="customerListTable"
                      @change="handleClick($event)"></b-pagination>
                </div>
              </div>
            </div>
            <!-- <div v-if="selectedCustomerType === 'P'" class="form-group">
               <label class="required"><b>Customers</b></label>
               <multiselect
               v-model="selectedCustomerId"
               @input="getcustomerDate()"
               :options="customers"
               :value="customers.customerId"
               :custom-label="customLabel"
               selected="selected"
               id="customersdd">
               </multiselect>
               </div>-->

               <div
              v-if="updateCustomerModal"
              @closeUpdateCustomerModal="closeUpdateCustomerModal()"
            >
              <div class="modal-backdrop">
                <div class="card col-lg-10 col-md-8 mt-md-4 col-11 p-0">
                  <div class="postmodalcontent">
                    <div class="modal-header borderbottom p-4">
                      <button
                        type="button"
                        class="close"
                        @click="closeUpdateCustomerModal"
                        data-dismiss="modal"
                        aria-label="Close"
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                    <div class="modal-body bodymodal11">
                      <nav class="navbar navbar-expand-lg bg-info text-white">
                      <span><b>Customer Demographics</b></span>
                    </nav>
                    <div
                      class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2"
                    >
                      <div
                        class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center"
                      >
                        <label
                          class="col-form-label col-form-label-sm"
                          id="prefixddlabel"
                          >Prefix</label
                        >
                      </div>
                      <div
                        class="col-12 col-md-12 align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3"
                      >
                        <select
                          id="prefixdd"
                          v-model="customer.selectedUserPrefixCode"
                          class="form-control input-sm"
                          :disabled="disabledfields"
                        >
                          <option value="">Select a Prefix...</option>
                          <option
                            v-for="(option, index) in userprefixs"
                            v-bind:value="option.userPrefixC"
                            :key="index"
                          >
                            {{ option.userPrefixX }}
                          </option>
                        </select>
                      </div>
                      <div
                        class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center"
                      >
                        <label
                          class="col-form-label col-form-label-sm"
                          id="custTypedd"
                          >Customer Type</label
                        >
                      </div>
                      <div
                        class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3"
                      >
                        <select
                          :disabled="disabledfields"
                          class="form-control input-sm"
                          @click="customerTypedropdown()"
                          v-model="customer.customerType"
                        >
                          <option disabled value="">Personal/Business</option>
                          <option
                            id="custType"
                            v-for="(option, index) in customertypelist"
                            v-bind:key="option.key"
                            v-bind:value="option.key"
                          >
                            {{ option.type }}
                          </option>
                        </select>
                      </div>
                    </div>
                    <div
                      class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2"
                    >
                      <div
                        class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center"
                        v-if="customer.customerType === ''"
                      >
                        <label
                          id="fnamelabel"
                          class="col-form-label col-form-label-sm"
                          >First Name</label
                        >
                      </div>
                      <div
                        class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3"
                        v-if="customer.customerType === ''"
                      >
                        <input
                          id="fname"
                          placeholder="Enter First Name"
                          v-model.trim="customer.firstName"
                          class="form-control input-sm"
                          size="20"
                          data-vv-name="First Name"
                          :disabled="disabledfields"
                          maxlength="50"
                          onkeypress="return (event.charCode > 64 && event.charCode < 91) || (event.charCode > 96 && event.charCode < 123)"
                        />
                        <div
                          v-if="errors.has('First Name')"
                          class="alert-danger"
                        >
                          {{ errors.first("First Name") }}
                        </div>
                      </div>
                      <div
                        class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center"
                        v-if="customer.customerType === 'Personal'"
                      >
                        <label
                          id="fnamelabel"
                          class="col-form-label col-form-label-sm required"
                          >First Name</label
                        >
                      </div>
                      <div
                        class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3"
                        v-if="customer.customerType === 'Personal'"
                      >
                        <input
                          id="fname"
                          placeholder="Enter First Name"
                          v-model.trim="customer.firstName"
                          class="form-control input-sm"
                          size="20"
                          v-validate="'required'"
                          data-vv-name="First Name"
                          :disabled="disabledfields"
                          maxlength="50"
                          onkeypress="return (event.charCode > 64 && event.charCode < 91) || (event.charCode > 96 && event.charCode < 123)"
                        />
                        <div
                          v-if="errors.has('First Name')"
                          class="alert-danger"
                        >
                          {{ errors.first("First Name") }}
                        </div>
                      </div>
                      <div
                        class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center"
                        v-if="customer.customerType === 'Business'"
                      >
                        <label
                          id="fnamelabel"
                          class="col-form-label col-form-label-sm"
                          >First Name</label
                        >
                      </div>
                      <div
                        class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3"
                        v-if="customer.customerType === 'Business'"
                      >
                        <input
                          id="fname"
                          placeholder="Enter First Name"
                          v-model.trim="customer.firstName"
                          class="form-control input-sm"
                          size="20"
                          data-vv-name="First Name"
                          :disabled="disabledfields"
                          maxlength="50"
                          onkeypress="return (event.charCode > 64 && event.charCode < 91) || (event.charCode > 96 && event.charCode < 123)"
                        />
                        <div
                          v-if="errors.has('First Name')"
                          class="alert-danger"
                        >
                          {{ errors.first("First Name") }}
                        </div>
                      </div>
                      <div
                        class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center"
                      >
                        <label
                          id="mnamelabel"
                          class="col-form-label col-form-label-sm"
                          >Middle Name</label
                        >
                      </div>
                      <div
                        class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3"
                      >
                        <input
                          id="mname"
                          placeholder="Enter Middle Name"
                          v-model.trim="customer.middleName"
                          class="form-control input-sm"
                          :disabled="disabledfields"
                          maxlength="50"
                          onkeypress="return (event.charCode > 64 && event.charCode < 91) || (event.charCode > 96 && event.charCode < 123)"
                        />
                      </div>
                      <div
                        class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center"
                      >
                        <label
                          id="lnamelabel"
                          class="col-form-label col-form-label-sm"
                          >Last Name</label
                        >
                      </div>
                      <div
                        class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3"
                      >
                        <input
                          id="lname"
                          placeholder="Enter Last Name"
                          v-model.trim="customer.lastName"
                          class="form-control input-sm"
                          data-vv-name="Last Name"
                          :disabled="disabledfields"
                          maxlength="50"
                          onkeypress="return (event.charCode > 64 && event.charCode < 91) || (event.charCode > 96 && event.charCode < 123)"
                        />
                        <div
                          v-if="errors.has('Last Name')"
                          class="alert-danger"
                        >
                          {{ errors.first("Last Name") }}
                        </div>
                      </div>
                    </div>
                    <div
                      class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 p-2"
                      v-if="customer.customerType === 'Business'"
                    >
                      <div
                        class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center"
                      >
                        <label
                          id="fnamelabel"
                          class="col-form-label col-form-label-sm required"
                          >Business Name</label
                        >
                      </div>
                      <div
                        class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3"
                      >
                        <input
                          id="Bname"
                          placeholder="Enter Business Name"
                          v-model.trim="customer.businessName"
                          class="form-control input-sm"
                          size="20"
                          v-validate="'required'"
                          data-vv-name="Business Name"
                          :disabled="disabledfields"
                          maxlength="50"
                          onkeypress="return (event.charCode > 64 && event.charCode < 91) || (event.charCode > 96 && event.charCode < 123) || event.charCode = 32 || event.charCode = 188 || event.charCode = 190"
                        />
                        <div
                          v-if="errors.has('Business Name')"
                          class="alert-danger"
                        >
                          {{ errors.first("Business Name") }}
                        </div>
                      </div>
                    </div>
                    <div
                      class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2"
                    >
                      <div
                        class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center"
                      >
                        <label
                          id="adr1label"
                          class="col-form-label col-form-label-sm"
                          >Address Line1</label
                        >
                      </div>
                      <div
                        class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3"
                      >
                        <input
                          id="adr1"
                          placeholder="Enter Address1"
                          v-model.trim="customer.addressLine1"
                          class="form-control input-sm"
                          :disabled="disabledfields"
                          maxlength="50"
                        />
                      </div>
                      <div
                        class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center"
                      >
                        <label
                          id="adr2label"
                          class="col-form-label col-form-label-sm"
                          >Address Line2</label
                        >
                      </div>
                      <div
                        class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3"
                      >
                        <input
                          id="adr2"
                          placeholder="Enter Address2"
                          v-model.trim="customer.addressLine2"
                          :disabled="disabledfields"
                          class="form-control input-sm"
                          maxlength="50"
                        />
                      </div>
                      <div
                        class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center"
                      >
                        <label
                          id="citylabel"
                          class="col-form-label col-form-label-sm"
                          >City</label
                        >
                      </div>
                      <div
                        class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3"
                      >
                        <input
                          id="city"
                          placeholder="Enter City"
                          v-model.trim="customer.city"
                          :disabled="disabledfields"
                          class="form-control input-sm"
                          maxlength="50"
                          onkeypress="return (event.charCode > 64 && event.charCode < 91) || (event.charCode > 96 && event.charCode < 123)"
                        />
                      </div>
                    </div>
                    <div
                      class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2"
                    >
                      <div
                        class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center"
                      >
                        <label
                          id="statesddlabel"
                          class="col-form-label col-form-label-sm"
                          >State</label
                        >
                      </div>
                      <div
                        class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3"
                      >
                        <select
                          id="statesdd"
                          v-model="customer.selectedStateCode"
                          class="form-control input-sm"
                          :disabled="disabledfields"
                        >
                          <option value="">Select a State...</option>
                          <option
                            v-for="(option, index) in states"
                            :value="option.stateFipsC"
                            :key="index"
                          >
                            {{ option.stateN }}
                          </option>
                        </select>
                      </div>
                      <div
                        class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center"
                      >
                        <label
                          id="zipcodelabel"
                          class="col-form-label col-form-label-sm"
                          >Zip Code</label
                        >
                      </div>
                      <div
                        class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3"
                      >
                        <input
                          id="zipcode"
                          placeholder="Enter 5 Digit zip"
                          v-model="customer.zipCode"
                          @input="zipDecoder"
                          title="Please enter 5 digits"
                          class="form-control input-sm"
                          :disabled="disabledfields"
                          maxlength="5"
                          v-validate="{ regex: /^(\d)(?!\1+$)/, digits: 5 }"
                          data-vv-name="Zip Code"
                          onkeypress="return !(event.charCode != 46 && event.charCode > 31 && (event.charCode < 48 || event.charCode > 57))"
                        />
                        <div v-if="errors.has('Zip Code')" class="alert-danger">
                          {{ errors.first("Zip Code") }}
                        </div>
                      </div>
                      <div
                        class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center"
                      >
                        <label
                          id="countrylabel"
                          class="col-form-label col-form-label-sm"
                          >Country</label
                        >
                      </div>
                      <div
                        class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3"
                      >
                        <input
                          id="country"
                          placeholder="Enter Country"
                          v-model="customer.countryName"
                          class="form-control input-sm"
                          disabled="true"
                        />
                      </div>
                    </div>
                    <div
                      class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2"
                    >
                      <div
                        class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center"
                      >
                        <label
                          id="emaillabel"
                          class="col-form-label col-form-label-sm"
                          >Email</label
                        >
                      </div>
                      <div
                        class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3"
                      >
                        <input
                          id="email"
                          placeholder="Enter email"
                          v-model.trim="customer.emailId"
                          class="form-control input-sm"
                          v-validate="'email'"
                          data-vv-name="Email"
                          ref="emailref"
                          :disabled="disabledfields"
                          maxlength="50"
                        />
                        <div v-if="errors.has('Email')" class="alert-danger">
                          {{ errors.first("Email") }}
                        </div>
                      </div>
                      <div
                        class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center"
                      >
                        <label
                          id="pnumlabel"
                          class="col-form-label col-form-label-sm"
                          >Primary/Cell Phone</label
                        >
                      </div>
                      <div
                        class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3"
                      >
                        <input
                          id="pnum"
                          placeholder="Enter Mobile Number"
                          v-model="customer.mobileNumber"
                          class="form-control input-sm"
                          :disabled="disabledfields"
                          maxlength="10"
                          title="Please enter 10 digits"
                          v-validate="'min:10|max:14'"
                          data-vv-name="Cell Phone"
                          @input="formatCellPhoneNumber"
                          @blur="formatCellPhoneNumber"
                        />
                        <div
                          v-if="errors.has('Cell Phone')"
                          class="alert-danger"
                        >
                          {{ errors.first("Cell Phone") }}
                        </div>
                        <div
                          v-if="this.fraudMobileError != ''"
                          class="alert-danger"
                        >
                          {{ fraudMobileError }}
                        </div>
                      </div>
                      <div
                        class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center"
                        v-if="customer.mobileNumber != ''"
                      >
                        <label
                          id="pnumlabel"
                          class="col-form-label col-form-label-sm"
                          >Fraud Cell</label
                        >
                      </div>
                      <!--col end-->
                      <div
                        class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3"
                        v-if="customer.mobileNumber != ''"
                      >
                        <select
                          name="fraudIndicator"
                          placeholder="Select fraudIndicator"
                          v-model.trim="customer.fraudMobileNumber"
                          class="form-control input-sm"
                          data-vv-as="indicator"
                          @change="changeFraudInd"
                          :disabled="disabledfields"
                        >
                          <option
                            v-for="indicator in fraudIndicatorList"
                            v-bind:key="indicator.key"
                          >
                            {{ indicator.keyValue }}
                          </option>
                        </select>
                      </div>
                      <!--col end-->
                    </div>
                    <div
                      class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2"
                    >
                      <div
                        class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center"
                      >
                        <label
                          id="wnumlabel"
                          class="col-form-label col-form-label-sm"
                          >Secondary/Work Phone</label
                        >
                      </div>
                      <div
                        class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3"
                      >
                        <input
                          id="wnum"
                          placeholder="Enter Work Number"
                          v-model="customer.workNumber"
                          class="form-control input-sm"
                          :disabled="disabledfields"
                          title="Please enter 10 digits"
                          maxlength="10"
                          v-validate="'min:10|max:14'"
                          data-vv-name="Work Phone"
                          @input="formatWorkPhoneNumber"
                          @blur="formatWorkPhoneNumber"
                        />
                        <div
                          v-if="errors.has('Work Phone')"
                          class="alert-danger"
                        >
                          {{ errors.first("Work Phone") }}
                        </div>
                      </div>
                      <div
                        class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center"
                      >
                        <label
                          id="fnumlabel"
                          class="col-form-label col-form-label-sm"
                          >Fax #</label
                        >
                      </div>
                      <div
                        class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3"
                      >
                        <input
                          id="fnum"
                          placeholder="Enter Fax Number"
                          v-model="customer.faxNumber"
                          class="form-control input-sm"
                          maxlength="10"
                          :disabled="disabledfields"
                          title="Please enter 10 digits"
                          v-validate="'min:10|max:14'"
                          data-vv-name="Fax"
                          @input="formatFaxNumber"
                          @blur="formatFaxNumber"
                        />
                        <div v-if="errors.has('Fax')" class="alert-danger">
                          {{ errors.first("Fax") }}
                        </div>
                      </div>
                    </div>
                    <div
                      class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2"
                    >
                      <div
                        class="col-12 col-md-12 d-flex justify-content-lg-end"
                      >
                        <label
                          id="statusddlabel"
                          class="col-form-label col-form-label-sm"
                          >Status</label
                        >
                      </div>
                      <div
                        class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3"
                      >
                        <select
                          id="statusdd"
                          v-model="customer.selectedCustomerStatus"
                          class="form-control input-sm"
                          :disabled="disabledfields"
                        >
                          <option
                            v-for="(option, index) in customerStatusOptions"
                            :value="option.value"
                            :key="index"
                          >
                            {{ option.text }}
                          </option>
                        </select>
                      </div>
                      <div
                        class="col-12 col-md-12 d-flex justify-content-lg-end"
                      >
                        <label
                          for="priority"
                          class="col-form-label col-form-label-sm"
                        >
                          New Eligibility Flag
                        </label>
                      </div>
                      <!--col end-->
                      <div
                        class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3"
                      >
                        <select
                          name="fraudIndicator"
                          v-model.trim="customer.fraudInd"
                          data-vv-as="indicator"
                          class="form-control input-sm"
                          @change="eligibilityFlag"
                          :disabled="disabledfields"
                        >
                          <option
                            v-for="(indicator, index) in fraudIndicatorList"
                            v-bind:key="indicator.key"
                          >
                            {{ indicator.keyValue }}
                          </option>
                        </select>
                      </div>
                      <!--col end-->
                      <div
                        class="col-12 col-md-12 d-flex justify-content-lg-end"
                      >
                        <label
                          for="priority"
                          class="col-form-label col-form-label-sm required"
                          v-if="
                            customer.fraudInd == 'N' ||
                            customer.fraudMobileNumber == 'Y' ||
                            customer.fraudInd == 'R'
                          "
                        >
                          Reg Flag Reason
                        </label>
                      </div>
                      <!--col end-->
                      <div
                        class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3"
                        v-if="
                          customer.fraudInd == 'N' ||
                          customer.fraudMobileNumber == 'Y'
                        "
                      >
                        <select
                          v-model.trim="customer.redFlagReason"
                          class="form-control input-sm"
                          v-validate="'required'"
                          data-vv-name="Red Flag Reason"
                          :disabled="disabledfields"
                        >
                          <option disabled value="">
                            Select Redflag Reason
                          </option>
                          <option v-if="customer.redFlagReason != ''">
                            {{ customer.redFlagReason }}
                          </option>
                          <option
                            v-for="(indicator, index) in redFlagReasonList"
                            v-bind:key="index"
                          >
                            {{ indicator.keyValue }}
                          </option>
                        </select>
                        <div
                          v-if="errors.has('Red Flag Reason')"
                          class="alert-danger"
                        >
                          {{ errors.first("Red Flag Reason") }}
                        </div>
                      </div>
                      <!--col end-->
                      <div
                        class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3"
                        v-if="customer.fraudInd == 'R'"
                      >
                        <select
                          v-model.trim="customer.redFlagReason"
                          class="form-control input-sm"
                          v-validate="'required'"
                          data-vv-name="Red Flag Reason"
                          :disabled="disabledfields"
                        >
                          <option disabled value="">
                            Select Redflag Reason
                          </option>
                          <option v-if="customer.redFlagReason != ''">
                            {{ customer.redFlagReason }}
                          </option>
                          <option
                            v-for="(indicator, index) in redFlagReasonList"
                            v-bind:key="index"
                          >
                            {{ indicator.keyValue }}
                          </option>
                        </select>
                        <div
                          v-if="errors.has('Red Flag Reason')"
                          class="alert-danger"
                        >
                          {{ errors.first("Red Flag Reason") }}
                        </div>
                      </div>
                      <!--col end-->
                    </div>
                    <br />
                    <div>
                      <div
                        class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2 justify-content-center"
                      >
                        <div class="center">
                          <button
                            class="btn btn-secondary"
                            type="submit"
                            @click="savecustomerdata"
                            :disabled="disabledfields"
                          >
                            Update</button
                          >
                        </div>
                      </div>
                    </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              v-if="updateDealerModal"
              @closeUpdateDealerModal="closeUpdateDealerModal()"
            >
              <div class="modal-backdrop">
                <div class="card col-lg-10 col-md-8 mt-md-4 col-11 p-0">
                  <div class="postmodalcontent">
                    <div class="modal-header borderbottom p-4">
                      <button
                        type="button"
                        class="close"
                        @click="closeUpdateDealerModal"
                        data-dismiss="modal"
                        aria-label="Close"
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                    <div class="modal-body bodymodal11">
                      <b v-if="customer.customerType == 'Business'"
                        >Summary Of {{ customer.businessName }}</b
                      >
                      <b v-else
                        >Summary Of
                        {{ customer.firstName + " " + customer.lastName }}</b
                      >
                      <div class="row p-2 justify-content-center">
                        <div class="col">
                          <div class="table-responsive table-responsive-sm">
                            <table
                              class="table table-sm table-bordered table-striped"
                            >
                              <thead class="table-month-header-red">
                                <tr>
                                  <th class="table-amort-header">
                                    Quote Count
                                  </th>
                                  <th class="table-amort-header">Apps Count</th>
                                  <th class="table-amort-header">
                                    Deals Count
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr
                                  class="table-month-row"
                                  v-for="(
                                    dealer, index
                                  ) in dealerListForDisplayIndex"
                                  :key="index"
                                >
                                  <td class="table-month-td">
                                    {{ dealer.quotesCount }}
                                  </td>
                                  <td class="table-month-td">
                                    {{ dealer.appsCount }}
                                  </td>
                                  <td class="table-month-td">
                                    {{ dealer.dealsCount }}
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                        <!--col end-->
                      </div>

                      <center>
                        <span :style="msgcolor">
                          <b>{{ responseMessage }}</b>
                        </span>
                      </center>
                      <br /><br />
                      <div class="row">
                        <div class="col-lg-3">
                          <ul class="nav nav-tabs" role="tablist">
                            <li class="nav-item">
                              <a
                                class="nav-link active"
                                data-toggle="tab"
                                href="#quotes"
                                role="tab"
                                @click="getAppsAndDeals('quote')"
                                >Quotes</a
                              >
                            </li>
                            <li class="nav-item">
                              <a
                                class="nav-link"
                                data-toggle="tab"
                                href="#apps"
                                role="tab"
                                @click="getAppsAndDeals('application')"
                                >Apps</a
                              >
                            </li>
                            <li>
                              <a
                                class="nav-link"
                                data-toggle="tab"
                                href="#deals"
                                role="tab"
                                @click="getAppsAndDeals('deals')"
                                >Deals</a
                              >
                            </li>
                          </ul>
                        </div>
                      </div>

                      <div class="tab-content" id="myTabContent">
                        <div
                          role="tabpanel"
                          class="tab-pane fade show active"
                          id="quotes"
                        >
                          <div>
                            <nav>
                              <div class="row mt-2 justify-content-center">
                                <div class="col">
                                  <div
                                    class="table-responsive table-responsive-sm tbl-update-dealer"
                                  >
                                    <v-table
                                      id="dealerListTable"
                                      :data="dealerListForDisplay"
                                      class="table table-sm table-bordered table-striped"
                                    >
                                      <thead
                                        class="table-month-header-blue wrap-text"
                                        slot="head"
                                      >
                                        <v-th sortKey="dateOfQuote"
                                          >Date Of Quote</v-th
                                        >
                                        <v-th sortKey="dealerName"
                                          >Dealer Name</v-th
                                        >
                                        <v-th sortKey="customerFirstName"
                                          >Customer First Name</v-th
                                        >
                                        <v-th sortKey="customerMiddleName"
                                          >Customer Middle Name</v-th
                                        >
                                        <v-th sortKey="customerLastName"
                                          >Customer Last Name</v-th
                                        >
                                        <v-th sortKey="customerBusinessName"
                                          >Customer Business Name</v-th
                                        >
                                        <v-th sortKey="customerType"
                                          >Customer Type</v-th
                                        >
                                        <v-th sortKey="capCost">Cap Cost</v-th>
                                        <v-th sortKey="dealerState"
                                          >Dealer State</v-th
                                        >
                                      </thead>
                                      <tbody
                                        slot="body"
                                        slot-scope="{ displayData }"
                                      >
                                        <tr
                                          v-for="(quote, dindex) in displayData"
                                          :key="dindex"
                                        >
                                          <td class="table-month-td">
                                            {{ quote.dateOfQuote }}
                                          </td>
                                          <td class="table-month-td">
                                            {{ quote.dealerName }}
                                          </td>
                                          <td class="table-month-td">
                                            {{ quote.customerFirstName }}
                                          </td>
                                          <td class="table-month-td">
                                            {{ quote.customerMiddleName }}
                                          </td>
                                          <td class="table-month-td">
                                            {{ quote.customerLastName }}
                                          </td>

                                          <td class="table-month-td">
                                            {{ quote.customerBusinessName }}
                                          </td>
                                          <td class="table-month-td">
                                            {{ quote.customerType }}
                                          </td>
                                          <td class="table-month-td">
                                            {{ quote.capCost }}
                                          </td>
                                          <td class="table-month-td">
                                            {{ quote.dealerState }}
                                          </td>
                                        </tr>
                                      </tbody>
                                    </v-table>
                                  </div>
                                </div>
                              </div>
                            </nav>
                          </div>
                          <div
                            class="row row-cols-lg-4 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2"
                          ></div>
                        </div>

                        <div role="tabpanel" class="tab-pane" id="apps">
                          <div>
                            <nav>
                              <div class="row mt-2 justify-content-center">
                                <div class="col">
                                  <div
                                    class="table-responsive table-responsive-sm tbl-update-dealer"
                                  >
                                    <v-table
                                      id="dealerListTable"
                                      :data="dealerListForDisplay"
                                      class="table table-sm table-bordered table-striped"
                                    >
                                      <thead
                                        class="table-month-header-blue wrap-text"
                                        slot="head"
                                      >
                                        <v-th sortKey="dateOfApplication"
                                          >Date Of Application</v-th
                                        >
                                        <v-th sortKey="dealerName"
                                          >Dealer Name</v-th
                                        >
                                        <v-th sortKey="customerFirstName"
                                          >Customer First Name</v-th
                                        >
                                        <v-th sortKey="customerMiddleName"
                                          >Customer Middle Name</v-th
                                        >
                                        <v-th sortKey="customerLastName"
                                          >Customer Last Name</v-th
                                        >
                                        <v-th sortKey="customerBusinessName"
                                          >Customer Business Name</v-th
                                        >
                                        <v-th sortKey="customerType"
                                          >Customer Type</v-th
                                        >
                                        <v-th sortKey="year">Year</v-th>
                                        <v-th sortKey="make">Make</v-th>
                                        <v-th sortKey="model">Model</v-th>
                                        <v-th sortKey="dealSource"
                                          >Deal Source</v-th
                                        >
                                        <v-th sortKey="applicationStatus"
                                          >Application Status</v-th
                                        >
                                        <v-th sortKey="appDeclineCategory"
                                          >App Decline Category</v-th
                                        >

                                        <v-th sortKey="appDeclineReason"
                                          >App Decline Reason</v-th
                                        >
                                        <v-th sortKey="expectedAdvance"
                                          >Expected Advance</v-th
                                        >
                                        <v-th sortKey="probToClose"
                                          >Prob to Close</v-th
                                        >
                                        <v-th sortKey="dealStatus"
                                          >Deal Status</v-th
                                        >
                                        <v-th sortKey="dealDeclineReason"
                                          >Deal Decline Reason</v-th
                                        >

                                        <v-th sortKey="appState"
                                          >App State</v-th
                                        >
                                        <v-th sortKey="fundedDate"
                                          >Funded Date</v-th
                                        >
                                      </thead>
                                      <tbody
                                        slot="body"
                                        slot-scope="{ displayData }"
                                      >
                                        <tr
                                          v-for="(quote, dindex) in displayData"
                                          :key="dindex"
                                        >
                                          <td class="table-month-td">
                                            {{ quote.dateOfApplication }}
                                          </td>
                                          <td class="table-month-td">
                                            {{ quote.dealerName }}
                                          </td>
                                          <td class="table-month-td">
                                            {{ quote.customerFirstName }}
                                          </td>
                                          <td class="table-month-td">
                                            {{ quote.customerMiddleName }}
                                          </td>
                                          <td class="table-month-td">
                                            {{ quote.customerLastName }}
                                          </td>
                                          <td class="table-month-td">
                                            {{ quote.customerBusinessName }}
                                          </td>
                                          <td class="table-month-td">
                                            {{ quote.customerType }}
                                          </td>
                                          <td class="table-month-td">
                                            {{ quote.year }}
                                          </td>
                                          <td class="table-month-td">
                                            {{ quote.make }}
                                          </td>
                                          <td class="table-month-td">
                                            {{ quote.model }}
                                          </td>
                                          <td class="table-month-td">
                                            {{ quote.dealSource }}
                                          </td>
                                          <td class="table-month-td">
                                            {{ quote.applicationStatus }}
                                          </td>
                                          <td class="table-month-td">
                                            {{ quote.appDeclineCategory }}
                                          </td>
                                          <td class="table-month-td">
                                            {{ quote.appDeclineReason }}
                                          </td>
                                          <td class="table-month-td">
                                            {{ quote.expectedAdvance }}
                                          </td>
                                          <td class="table-month-td">
                                            {{ quote.probToClose }}
                                          </td>
                                          <td class="table-month-td">
                                            {{ quote.dealStatus }}
                                          </td>
                                          <td class="table-month-td">
                                            {{ quote.dealDeclineReason }}
                                          </td>
                                          <td class="table-month-td">
                                            {{ quote.appState }}
                                          </td>
                                          <td class="table-month-td">
                                            {{ quote.fundedDate }}
                                          </td>
                                        </tr>
                                      </tbody>
                                    </v-table>
                                  </div>
                                </div>
                              </div>
                            </nav>
                          </div>
                          <div
                            class="row row-cols-lg-4 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2"
                          ></div>
                        </div>
                        <div role="tabpanel" class="tab-pane" id="deals">
                          <div>
                            <nav>
                              <div class="row mt-2 justify-content-center">
                                <div class="col">
                                  <div
                                    class="table-responsive table-responsive-sm tbl-update-dealer"
                                  >
                                    <v-table
                                      id="dealerListTable"
                                      :data="dealerListForDisplay"
                                      class="table table-sm table-bordered table-striped"
                                    >
                                      <thead
                                        class="table-month-header-blue wrap-text"
                                        slot="head"
                                      >
                                        <v-th sortKey="dateOfApplication"
                                          >Date Of Application</v-th
                                        >
                                        <v-th sortKey="dealerName"
                                          >Dealer Name</v-th
                                        >
                                        <v-th sortKey="customerFirstName"
                                          >Customer First Name</v-th
                                        >
                                        <v-th sortKey="customerMiddleName"
                                          >Customer Middle Name</v-th
                                        >
                                        <v-th sortKey="customerLastName"
                                          >Customer Last Name</v-th
                                        >
                                        <v-th sortKey="customerBusinessName"
                                          >Customer Business Name</v-th
                                        >
                                        <v-th sortKey="customerType"
                                          >Customer Type</v-th
                                        >
                                        <v-th sortKey="year">Year</v-th>
                                        <v-th sortKey="make">Make</v-th>
                                        <v-th sortKey="model">Model</v-th>
                                        <v-th sortKey="dealSource"
                                          >Deal Source</v-th
                                        >
                                        <v-th sortKey="applicationStatus"
                                          >Application Status</v-th
                                        >
                                        <v-th sortKey="appDeclineCategory"
                                          >App Decline Category</v-th
                                        >

                                        <v-th sortKey="appDeclineReason"
                                          >App Decline Reason</v-th
                                        >
                                        <v-th sortKey="expectedAdvance"
                                          >Expected Advance</v-th
                                        >
                                        <v-th sortKey="probToClose"
                                          >Prob to Close</v-th
                                        >
                                        <v-th sortKey="dealStatus"
                                          >Deal Status</v-th
                                        >
                                        <v-th sortKey="dealDeclineReason"
                                          >Deal Decline Reason</v-th
                                        >

                                        <v-th sortKey="appState"
                                          >App State</v-th
                                        >
                                        <v-th sortKey="fundedDate"
                                          >Funded Date</v-th
                                        >
                                      </thead>
                                      <tbody
                                        slot="body"
                                        slot-scope="{ displayData }"
                                      >
                                        <tr
                                          v-for="(quote, dindex) in displayData"
                                          :key="dindex"
                                        >
                                          <td class="table-month-td">
                                            {{ quote.dateOfApplication }}
                                          </td>
                                          <td class="table-month-td">
                                            {{ quote.dealerName }}
                                          </td>
                                          <td class="table-month-td">
                                            {{ quote.customerFirstName }}
                                          </td>
                                          <td class="table-month-td">
                                            {{ quote.customerMiddleName }}
                                          </td>
                                          <td class="table-month-td">
                                            {{ quote.customerLastName }}
                                          </td>
                                          <td class="table-month-td">
                                            {{ quote.customerBusinessName }}
                                          </td>
                                          <td class="table-month-td">
                                            {{ quote.customerType }}
                                          </td>
                                          <td class="table-month-td">
                                            {{ quote.year }}
                                          </td>
                                          <td class="table-month-td">
                                            {{ quote.make }}
                                          </td>
                                          <td class="table-month-td">
                                            {{ quote.model }}
                                          </td>
                                          <td class="table-month-td">
                                            {{ quote.dealSource }}
                                          </td>
                                          <td class="table-month-td">
                                            {{ quote.applicationStatus }}
                                          </td>
                                          <td class="table-month-td">
                                            {{ quote.appDeclineCategory }}
                                          </td>
                                          <td class="table-month-td">
                                            {{ quote.appDeclineReason }}
                                          </td>
                                          <td class="table-month-td">
                                            {{ quote.expectedAdvance }}
                                          </td>
                                          <td class="table-month-td">
                                            {{ quote.probToClose }}
                                          </td>
                                          <td class="table-month-td">
                                            {{ quote.dealStatus }}
                                          </td>
                                          <td class="table-month-td">
                                            {{ quote.dealDeclineReason }}
                                          </td>
                                          <td class="table-month-td">
                                            {{ quote.appState }}
                                          </td>
                                          <td class="table-month-td">
                                            {{ quote.fundedDate }}
                                          </td>
                                        </tr>
                                      </tbody>
                                    </v-table>
                                  </div>
                                </div>
                              </div>
                            </nav>
                          </div>
                        </div>

                        <center>
                          <button
                            @click="closeUpdateDealerModal"
                            class="btn btn-secondary mb-3"
                          >
                            Back
                          </button>
                        </center>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <br />
            <br />
          </div>
          <!-- End of the code for this screen here -->
        </div>
        <bottom-footer></bottom-footer>
      </div>
    </div>
  <!-- </div> -->
</template>
<script>
import TopHeader from '@/components/TopHeader.vue'
import BottomFooter from '@/components/BottomFooter.vue'
import MainMenu from '@/components/Menu.vue'
import httpcommon from '../js/http-common.js'
import httpcommonzero from '../js/http-common-zero.js'
import httpcustomer from '../js/http-customer.js'
import multiselectcss from '@/css/vue-multiselect.min.css'
import manageSourceSvc from '../js/http-managesource'
import { bus } from '../main'
import { debug } from 'util'
import { hasAccess } from '../js - Local/permissions.js'
export default {
  components: { MainMenu, TopHeader, BottomFooter, multiselectcss },
  data () {
    return {
      updateDealerModal: false,
      updateCustomerModal: false,
      responseMessage: '',
      viewDealsType: 'quote',
      viewDealsCountType: 'customer',
      dealerListForDisplay: [],
      dealerListForDisplayIndex: [],
      fraudIndicatorList: [],
      businesscustomerlist: [],
      message: '',
      isHidden: false,
      selectedCustomerId: '',
      disabledfields: 'disabled',
      requiredfieldcontent: '*',
      selectedCustomerType: '',
      customers: [],
      userprefixs: [],
      customersList: [],
      searchCriteria: {
        firstName: '',
        middleName: '',
        lastName: '',
        businessName: '',
        email: '',
        state: '',
        city: '',
        fraudInd: ''
      },
      states: [],
      redFlagReasonList: [],
      customerStatusOptions: [],
      customertypelist: [
        { key: 'Personal', type: 'Personal' },
        { key: 'Business', type: 'Business' }
      ],
      preferredContactOptions: [],
      fraudMobileError: '',
      customer: this.createEmptyCustomerObject(),
      msgcolor: {
        color: 'black'
      },
      cuserrorslist: [],
      addcustomer: [],
      existingEmailIds: [],
      isLoading: false,
      fraudIndOptions: [
        { name: 'R', value: 'R' },
        { name: 'Y', value: 'Y' },
        { name: 'N', value: 'N' }
      ],
      currentPage: 1,
      pageSize: 5,
      totalRows: 0
    }
  },
  methods: {

    success (message) {
      this.$toasted.success(message).goAway(2000)
    },
    error (message) {
      this.$toasted.error(message).goAway(2000)
    },
    // Fetches posts when the component is created.
    fetchData () {
      this.searchCriteria.fraudInd = ''
      this.retrieveCustomerList()
      this.retrieveUserPrefixList()
      this.retrieveStateList()
      this.retrievePreferredContact()
      this.retrieveStatus()
      this.retrieveEmailIds()
      bus.$emit('customerId', '1') // use this for passing information to other page.
    },
    zipDecoder () {
      if (this.customer.zipCode.length == 5) {
        httpcommon
          .get('/statefip/zipCode/' + this.customer.zipCode)
          .then((response) => {
            if (response.data.city != null) {
              this.customer.city = response.data.city
            } else {
              this.customer.city = ''
            }
            if (response.data.city != null) {
              this.getCustomerStateDetails(response.data.state)
            } else {
              this.customer.selectedStateCode = ''
            }
          })

          .catch((e) => {
            this.errorslist.push(e)
          })
      }
    },
    getCustomerStateDetails (stateFipsC) {
      for (let i = 0; i < this.states.length; i++) {
        if (this.states[i].stateAlphaC == stateFipsC) {
          // this.customer.selectedStateCode = this.states[i];
          this.customer.selectedStateCode = this.states[i].stateFipsC
        }
      }
    },
    createeEmptySearchObject () {
      return {
        firstName: '',
        middleName: '',
        lastName: '',
        businessName: '',
        email: '',
        state: '',
        city: '',
        fraudInd: ''
      }
    },
    closeUpdateDealerModal () {
      this.updateDealerModal = false
    },
    closeUpdateCustomerModal () {
      this.updateCustomerModal = false
    },
    getAppsAndDeals (value) {
      (this.dealerListForDisplay = []), (this.responseMessage = '')
      this.viewDealsType = value
      manageSourceSvc
        .get('/getCustomerAppsAndDealsData', {
          params: {
            viewDealsType: this.viewDealsType,
            customerId: this.selectedCustomerId
          }
        })
        .then((Response) => {
          this.dealerListForDisplay = Response.data

          if (this.dealerListForDisplay == '') {
            this.responseMessage = 'No Records Found'
          }
        })
        .catch((error) => {
          console.log('Failed to load dealer on page load:' + error)
          this.error = true
        })
        .finally(() => (this.loading = false))
    },

    getAppsAndDealsIndex (value) {
      this.viewDealsCountType = value
      manageSourceSvc
        .get('/getAppsAndDealsDataCount', {
          params: {
            viewDealsType: this.viewDealsCountType,
            dealerName: '',
            customerId: this.selectedCustomerId
          }
        })
        .then((Response) => {
          this.dealerListForDisplayIndex = Response.data
        })
        .catch((error) => {
          console.log('Failed to load dealer on page load:' + error)
          this.error = true
        })
        .finally(() => (this.loading = false))
    },

    displayFullName (option) {
      if (option.customerType == 'P') {
        return `${option.firstName} ${
          option.middleName != null && option.middleName.length != 0
            ? ',' + option.middleName
            : ''
        } ,${
          option.lastName != null && option.lastName.length != 0
            ? option.lastName
            : ''
        }`
      } else if (option.customerType == 'B') {
        return `${option.businessName}`
      }
    },
    createEmptyCustomerObject () {
      return {
        selectedUserPrefixCode: '',
        selectedCustomerId: '',
        firstName: '',
        middleName: '',
        lastName: '',
        businessName: '',
        addressId: '',
        addressLine1: '',
        addressLine2: '',
        city: '',
        selectedStateCode: '',
        countryName: '',
        fraudInd: 'Y',
        zipCode: '',
        digitalContactId: '',
        existingEmailId: '',
        emailId: '',
        confirmEmailId: '',
        workNumber: '',
        mobileNumber: '',
        faxNumber: '',
        preferredContactCode: 'A',
        selectedCustomerStatus: 'A',
        customerType: '',
        createdDate: '',
        createdUserId: '',
        redFlagReason: '',
        fraudMobileNumber: 'N'
      }
    },

    customerTypedropdown () {
      if (this.customer.customerType === 'Business') {
        httpcustomer
          .get('/customer/' + this.selectedCustomerId)
          .then((response) => {
            var customerlist = response.data
            var customerobject = customerlist[0]
            this.customer.businessName = customerobject.businessName
          })
      } else if (this.customer.customerType === 'Personal') {
        this.customer.businessName = ''
      }
    },

    retrieveEmailIds () {
      httpcommonzero
        .get('/digitalcontactinfo/')
        .then((response) => {
          this.existingEmailIds = response.data
        })
        .catch((e) => {
          this.cuserrorslist.push(e)
        })
    },

    onSearch () {
      this.currentPage = 1
      this.pageSize = 5
      this.retrieveCustomerList()
    },
    resetsearch () {
      // const hasSearchCriteria = Object.values(this.searchCriteria).some(value => value !== null && value !== '');
      // if (hasSearchCriteria) {
      this.searchCriteria = this.createeEmptySearchObject()
      this.customersList = []
      this.totalRows = 0
      this.currentPage = 1,
      this.pageSize = 5,
      this.retrieveCustomerList()
      // this.message = ''
  // }
      
    },
    handleClick (event) {
      this.currentPage = event
      this.retrieveCustomerList()
    },
    retrieveCustomerList () {
      this.customersList = []
      this.isLoading = true
      httpcustomer
        .get(`/customer/search`, {
          params: {
            firstName: this.searchCriteria.firstName === '' ? null : this.searchCriteria.firstName,
            middleName: this.searchCriteria.middleName === '' ? null : this.searchCriteria.middleName,
            lastName: this.searchCriteria.lastName === '' ? null : this.searchCriteria.lastName,
            businessName: this.searchCriteria.businessName === '' ? null : this.searchCriteria.businessName,
            email: this.searchCriteria.email === '' ? null : this.searchCriteria.email,
            stateN: this.searchCriteria.state === '' ? null : this.searchCriteria.state,
            city: this.searchCriteria.city === '' ? null : this.searchCriteria.city,
            fraudInd: this.searchCriteria.fraudInd === '' ? null : this.searchCriteria.fraudInd,
            page: this.currentPage,
            size: this.pageSize
          }
        })
        .then((response) => {
          this.customersList = response.data.content
          this.totalRows = response.data.totalCount
        })
        .catch((e) => {
          console.log(e)
          this.errors.push(e)
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    retrieveUserPrefixList () {
      httpcommon
        .get('/userprefix/')
        .then((response) => {
          this.userprefixs = response.data
        })
        .catch((e) => {
          this.cuserrorslist.push(e)
        })
    },
    retrieveStateList () {
      httpcommon
        .get('/statefip/')
        .then((response) => {
          this.states = response.data
        })
        .catch((e) => {
          this.cuserrorslist.push(e)
        })
    },
    retrievePreferredContact () {
      httpcommon
        .get('/staticdata/preferredcontact/')
        .then((response) => {
          this.preferredContactOptions = response.data
        })
        .catch((e) => {
          this.cuserrorslist.push(e)
        })
    },
    retrieveStatus () {
      httpcommon
        .get('/staticdata/status/')
        .then((response) => {
          this.customerStatusOptions = response.data
        })
        .catch((e) => {
          this.cuserrorslist.push(e)
        })
    },
    emailIdNotInTheSystem () {
      if (this.customer.emailId.length > 0 && this.isNewEmailIdCaptured()) {
        for (var i = 0; i < this.existingEmailIds.length; i++) {
          var obj = this.existingEmailIds[i]
          if (obj.email == this.customer.emailId) {
            this.error('Email already exists. Please choose a different email id.')
            // this.message =
            // 'Email already exists. Please choose a different email id.'
            // this.msgcolor.color = 'Red'
            this.$validator.flag('Email', {
              valid: false,
              invalid: true
            })
            this.$validator.flag('ReEnter Email', {
              valid: false,
              invalid: true
            })
            return false
          }
        }
      }
      // this.message = ''
      return true
    },
    changeFraudInd () {
      if (
        this.customer.fraudInd == 'Y' &&
        this.customer.fraudMobileNumber == 'N'
      ) {
        this.customer.redFlagReason = ''
      }
      if (this.customer.fraudMobileNumber == 'N') {
        this.fraudMobileError = ''
      }
    },
    eligibilityFlag () {
      if (this.customer.fraudInd === 'R') {
        this.customer.redFlagReason = 'Review'
      } else {
        this.customer.redFlagReason = ''
      }
    },
    isNewEmailIdCaptured () {
      if (this.customer.existingEmailId == this.customer.emailId) {
        return false
      } else {
        return true
      }
    },
    formatCellPhoneNumber: function (event) {
      this.getCustomerMobileFraud()
      var phone = this.customer.mobileNumber
      phone = phone
        .replace(/[^0-9]/g, '')
        .replace(/(\d{3})(\d{3})(\d{4})/g, '($1) $2-$3')
      this.customer.mobileNumber = phone
      if (this.customer.mobileNumber == '') {
        this.customer.fraudMobileNumber = 'N'
      }
    },
    formatWorkPhoneNumber: function (event) {
      var phone = this.customer.workNumber
      phone = phone
        .replace(/[^0-9]/g, '')
        .replace(/(\d{3})(\d{3})(\d{4})/g, '($1) $2-$3')
      this.customer.workNumber = phone
    },
    formatFaxNumber: function (event) {
      var phone = this.customer.faxNumber
      phone = phone
        .replace(/[^0-9]/g, '')
        .replace(/(\d{3})(\d{3})(\d{4})/g, '($1) $2-$3')
      this.customer.faxNumber = phone
    },
    Reset (value) {
      this.customer = this.createEmptyCustomerObject()
      this.$validator.reset()
      // this.message = ''
      this.selectedCustomerId = ''
      // Get the Customer names
      this.retrieveCustomerList(value)
    },
    getcustomerDate (customerId) {
      this.updateCustomerModal = true
      this.selectedCustomerId = customerId
      // this.message = ''
      this.$validator.reset()
      this.fraudMobileError = ''
      if (customerId) {
        httpcustomer
          .get('/customer/' + customerId)
          .then((response) => {
            var customerlist = response.data
            var customerobject = customerlist[0]
            if (
              customerobject.customerId === customerId
            ) {
              this.customer = {
                selectedUserPrefixCode:
                  customerobject.userPrefixC == null
                    ? ''
                    : customerobject.userPrefixC,
                firstName: customerobject.firstName,
                middleName: customerobject.middleName,
                lastName: customerobject.lastName,
                businessName: customerobject.businessName,
                customerType:
                  customerobject.customerType == 'P' ? 'Personal' : 'Business',
                addressId: customerobject.address.addressId,
                addressLine1: customerobject.address.street1,
                addressLine2: customerobject.address.street2,
                city: customerobject.address.city,
                selectedStateCode:
                  customerobject.address.stateFipsC == null
                    ? ''
                    : customerobject.address.stateFipsC,
                countryName: customerobject.address.country,
                fraudInd: customerobject.fraudInd,
                redFlagReason:
                  customerobject.redFlagReason == null
                    ? ''
                    : customerobject.redFlagReason,
                zipCode: customerobject.address.zipCode,
                digitalContactId:
                  customerobject.digitalContactInfo.digitalContactId,
                existingEmailId: customerobject.digitalContactInfo.email,
                emailId: customerobject.digitalContactInfo.email,
                // confirmEmailId: customerobject.digitalContactInfo.email,
                workNumber:
                  customerobject.digitalContactInfo.workNumber == null
                    ? ''
                    : customerobject.digitalContactInfo.workNumber.replace(
                      /(\d{3})(\d{3})(\d{4})/g,
                      '($1) $2-$3'
                    ),
                mobileNumber:
                  customerobject.digitalContactInfo.mobileNumber == null
                    ? ''
                    : customerobject.digitalContactInfo.mobileNumber.replace(
                      /(\d{3})(\d{3})(\d{4})/g,
                      '($1) $2-$3'
                    ),
                faxNumber:
                  customerobject.digitalContactInfo.faxNumber == null
                    ? ''
                    : customerobject.digitalContactInfo.faxNumber.replace(
                      /(\d{3})(\d{3})(\d{4})/g,
                      '($1) $2-$3'
                    ),
                fraudMobileNumber:
                  customerobject.digitalContactInfo.fraudMobileNumber == null
                    ? 'N'
                    : customerobject.digitalContactInfo.fraudMobileNumber,
                preferredContactCode:
                  customerobject.digitalContactInfo.preferredContact,
                selectedCustomerStatus:
                  customerobject.inactiveD == null ? 'A' : 'IA',
                createdDate: customerobject.creationD,
                createdUserId: customerobject.creationUserI
              }
            }
            if (this.customer.mobileNumber != '') {
              this.getCustomerMobileFraud()
            }
          })
          .catch((e) => {
            this.cuserrorslist.push(e)
          })
        this.disabledfields = false
      } else {
        this.disabledfields = 'disabled'
        this.customer = this.createEmptyCustomerObject()
      }
      this.dealerListForDisplayIndex = []
    },
    viewDealsApps (customerId) {
      this.updateDealerModal = true
      this.selectedCustomerId = customerId
      this.getAppsAndDeals('quote')
      this.getAppsAndDealsIndex(this.viewDealsCountType)
    },
    updateCustomer () {
      var currentDate = new Date()
      let existingCustomer = {
        customerId: this.selectedCustomerId,
        firstName: this.customer.firstName,
        middleName: this.customer.middleName,
        lastName: this.customer.lastName,
        fraudInd: this.customer.fraudInd,
        customerobject: this.customer.customerobject,
        businessName:
          this.customer.customerType == 'Personal'
            ? ''
            : this.customer.businessName,
        customerType: this.customer.customerType == 'Personal' ? 'P' : 'B',
        dealerId: null,
        userPrefixC:
          this.customer.selectedUserPrefixCode.length == 0
            ? null
            : this.customer.selectedUserPrefixCode,
        address: {
          addressId: this.customer.addressId,
          street1: this.customer.addressLine1,
          street2: this.customer.addressLine2,
          city: this.customer.city,
          zipCode: this.customer.zipCode,
          stateFipsC:
            this.customer.selectedStateCode != null &&
            this.customer.selectedStateCode.length > 0
              ? this.customer.selectedStateCode
              : null,
          country: this.customer.countryName,
          addressType: null,
          inactiveD: null,
          creationD: this.customer.createdDate,
          creationUserI: this.customer.createdUserId,
          lastUpdatedD: currentDate,
          lastUpdatedUserI: this.$session.get('user_id')
        },
        digitalContactInfo: {
          digitalContactId: this.customer.digitalContactId,
          email: this.customer.emailId,
          faxNumber: this.customer.faxNumber.replace(/[^0-9]/g, ''),
          mobileNumber: this.customer.mobileNumber.replace(/[^0-9]/g, ''),
          fraudMobileNumber: this.customer.fraudMobileNumber,
          preferredContact: this.customer.preferredContactCode,
          workNumber: this.customer.workNumber.replace(/[^0-9]/g, '')
        },
        inactiveD:
          this.customer.selectedCustomerStatus == 'A' ? null : currentDate,
        creationD: this.customer.createdDate,
        creationUserI: this.customer.createdUserId,
        redFlagReason:
          this.customer.redFlagReason == ''
            ? null
            : this.customer.redFlagReason,
        lastUpdatedD: currentDate,
        lastUpdatedUserI: this.$session.get('user_id')
      }
      httpcustomer
        .put('/customer/', existingCustomer)
        .then((response) => {
          var status = response.data

          if (status == 'ACCEPTED') {
            // this.message =
            //   'Successfully updated Customer information into the system'
            // this.msgcolor.color = 'Blue'
            this.success('Successfully updated Customer information into the system')
            this.customer = this.createEmptyCustomerObject()
            this.selectedCustomerId = ''
            this.disabledfields = 'disabled'
            this.retrieveCustomerList()
          } else {
            // this.msgcolor.color = 'Red'
            // this.message = status
            this.error(status)
          }
        })
        .catch((e) => {
          console.log(e)
          // this.msgcolor.color = 'Red'
          // this.message = e.name || e.message
          this.error(e.name || e.message)
        })
    },
    savecustomerdata: function () {
      this.$validator.validateAll().then(() => {
        if (!this.errors.any()) {
          if (this.emailIdNotInTheSystem()) {
            this.updateCustomer()
            this.fraudMobileError = ''
            this.updateCustomerModal = false
          }
        }
      })
    },
    getCustomerMobileFraud () {
      if (this.customer.mobileNumber != '') {
        httpcustomer
          .get(
            '/customer/checkfraudMobileNumber/' +
              this.customer.mobileNumber.replace(/[^0-9]/g, '')
          )
          .then((response) => {
            if (response.data == 'Y') {
              this.fraudMobileError = 'The given MobileNumber is blocked'
            } else {
              this.fraudMobileError = ''
              this.customer.fraudMobileNumber = 'N'
              this.changeFraudInd()
            }
          })
      }
    },
    myFunction () {
      var elmnt = document.getElementById('height2')
      var elmnt1 = document.getElementById('height3')
      var txt = elmnt.offsetHeight
      var width = elmnt.offsetWidth
      var txt1 = elmnt1.offsetHeight
      var ht = txt + txt1
      $('#customer').css('margin-top', txt + txt1 + 3)
    },
    menuheight () {
      var elmnt = document.getElementById('height2')
      var txt = elmnt.offsetHeight
      $('#height3').css('margin-top', txt)
    },
    checkAccess (permission) {
      return hasAccess(permission)
    }
  },
  created () {
    window.addEventListener('resize', this.myFunction)
    window.addEventListener('resize', this.menuheight)
  },

  mounted () {
    this.myFunction()
    this.menuheight()
    httpcommon
      .get('/keyvalues/getkeyvalues/' + 1)
      .then((response) => {
        this.fraudIndicatorList = response.data
      })
      .catch((e) => {
        this.errorslist.push(e)
      })
    httpcommon
      .get('/keyvalues/getkeyvalues/' + 23)
      .then((response) => {
        this.redFlagReasonList = response.data
      })
      .catch((e) => {
        this.errorslist.push(e)
      })
    this.fetchData()
  }
}
</script>
<style scoped>
.radioButton {
  margin-left: 10%;
}
.modal-backdrop {
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1000 !important;
}
.pageloader {
  width: 7%;
  margin-top: 5%;
  margin-bottom: 5%;
  margin-left: 46%;
}
#introVideo {
  width: 100%;
  background: black;
}
.card {
  padding: -5px !important;
  margin: 0 auto;
}
label input[type="radio"]:checked ~ span {
  color: #007aff;
}
.postmodalcontent {
  border: none !important;
}
.btn:focus {
  box-shadow: none;
}
.tagLineReport {
  height: 10px;
  color: #1f1f1f;
  font-size: 10px;
  font-weight: bold;
  letter-spacing: 0;
  font-style: italic;
  opacity: 60%;
}
.button-cancel11 {
  border: 1px solid #1f1f1f;
  border-radius: 4px;
  transition: ease-out 0.3s;
  font-size: 14px !important;
  position: relative;
  z-index: 1;
}
.modal-header {
  border: none;
}
.bodymodal11 {
  padding: 0 !important;
  height: 80vh;
  overflow-y: auto;
}
.bodymodal11 {
  background-color: white;
}
.profile-border {
  padding: 2px;
  border: 2px solid #ced4da;
  border-radius: 50%;
}
/*hide scroll bar */
/*.bodymodal11::-webkit-scrollbar {
  display: none;
}*/
/* Hide scrollbar for IE, Edge and Firefox */

/*.bodymodal11 {
  -ms-overflow-style: none;
  scrollbar-width: none;
}*/
.close {
  padding: 1px 7px 5px 7px !important;
  margin-top: -3px !important;
  margin-right: 5px !important;
}
.close:hover {
  background-color: rgba(161, 166, 179, 0.1);
  border-radius: 60%;
  border: 1px solid rgba(161, 166, 179, 0.5);
}
.loadingBgImg {
  background: transparent url("../assets/logout.png") center no-repeat;
  background-size: 30px 30px;
}
@media screen and (max-width: 600px) {
  .card {
    margin-top: 4%;
  }
}
.nav-link {
  display: block;
  padding: 0.5rem 1rem;
  background-color: #17a2b8;
  color: black;
  margin-left: 5px;
}
.nav-tabs .nav-item.show .nav-link,
.nav-tabs .nav-link.active {
  color: black;
  background-color: white;
  border-color: #a9a9a9;
  border-bottom: none;
}
.sidebyside {
  float: right;
}
.disabled {
  pointer-events: none;
  cursor: none;
}
</style>
